const key = "add-unknown-field";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const ruleJson = (invalidFieldId) => ({
	"Id": 3,
	"Title": "Unknown Field",
	"Operator":
	{
		"Id": 2,
		"Code": "OR",
		"Name": "Or"
	},
	"Engine":
	{
		"Id": 4,
		"Code": "EMPTY",
		"Name": "Empty"
	},
	"Conditions":
	[
		{
			"Id": 1,
			"Field":
			{
				"Id": invalidFieldId
			}
		}
	],
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 1,
				"Code": "BLOCKSAVE",
				"Name": "Block Saving"
			},
			"Type":
			{
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

function getRandomInt(max) {
	return Math.floor(Math.random() * max);
}

const modify = (resp) => {
	if(!resp.data.Data?.Rules || !resp.data.Data?.Fields) {
		return;
	}

	const validFieldIds = resp.data.Data.Fields.map(f => f.Id);

	let invalidFieldId;
	do {
		invalidFieldId = getRandomInt(10000); 
	} while(validFieldIds.indexOf(invalidFieldId) > -1); 

	const ruleWithUnknownFieldId = ruleJson(invalidFieldId);
	resp.data.Data.Rules.push(ruleWithUnknownFieldId);
};

export const addUnknownFieldId = [key, applicable, modify];